export * from './Core';
import { SearchModule } from './Angular/SearchModule';

let Angular = {
	SearchModule: SearchModule
};

export { Angular };
